import React from 'react';

const Search = (props) => {
	return (
		<div className="search-box">
			<input
				type="text"
				placeholder="Search..."
				onChange={(e) => props.customFunc(e.target.value.toLowerCase())}
			/>
			<i className="fas fa-search" />
		</div>
	);
};

export default Search;
